import { AppConfigModel } from './models/config.model';
import { Component, OnInit, OnDestroy, afterNextRender, Renderer2, Inject } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { AppToastService } from './services/app-toast.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from './services/app-config.service';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription> = [];
  title = 'hr-client';
  showLoading: boolean;
  blockedDocument: boolean;
  config: AppConfigModel;
  theme = 'saga-blue';
  public subscription: Subscription;

  constructor(private primengConfig: PrimeNGConfig,
    @Inject(DOCUMENT) private document: Document,
    private toastService: AppToastService,
    private messageService: MessageService,
    private renderer: Renderer2,
    private primeNGconfig: PrimeNGConfig,
    private translate: TranslateService,
    private router: Router,
    private configService: AppConfigService) {
    afterNextRender(() => {
      // if (process.env.NODE_ENV === 'production') {
      //   this.injectScripts();
      // }

      this.bindRouteEvents();
    });
  }

  ngOnInit() {

    this.translate.get('primeng').subscribe(res => this.primeNGconfig.setTranslation(res));

    this.primengConfig.ripple = true;
    // Show success
    this.subscriptions.push(this.toastService.subSuccessCalled$.subscribe(({ summary, detail, sticky, lifeTime }) => this.showSuccess(summary, detail, sticky, lifeTime)));
    // Show error
    this.subscriptions.push(this.toastService.subErrorCalled$.subscribe(({ summary, detail, sticky, lifeTime }) => this.showError(summary, detail, sticky, lifeTime)));
    // Show warn
    this.subscriptions.push(this.toastService.subWarningCalled$.subscribe(({ summary, detail, sticky, lifeTime }) => this.showWarning(summary, detail, sticky, lifeTime)));
    // Show info
    this.subscriptions.push(this.toastService.subInfoCalled$.subscribe(({ summary, detail, sticky, lifeTime }) => this.showInfo(summary, detail, sticky, lifeTime)));

    // Block Document
    this.blockedDocument = false;
    this.subscriptions.push(this.toastService.subBlockDocumentCalled$.subscribe((blocked) => this.blockDocument(blocked)));

    // this.config = this.configService.config;
    this.configService.onConfigUpdate();
  }

  changeTheme(event) {
    const themeElement = document.getElementById('theme-link');
    themeElement.setAttribute('href', themeElement.getAttribute('href').replace(this.theme, event.theme));
    this.theme = event.theme;

    this.config.dark = event.dark;
    this.config.theme = this.theme;
    // this.configService.updateConfig(this.config);

    if (event.theme.startsWith('md')) {
      this.config.ripple = true;
    }

    if (this.config.theme === 'nano') {
      this.applyScale(12);
    }

  }

  isDarkTheme(theme) {
    return theme.indexOf('dark') !== -1 || theme.indexOf('vela') !== -1 || theme.indexOf('arya') !== -1 || theme.indexOf('luna') !== -1;
  }

  applyScale(scale: number) {
    document.documentElement.style.fontSize = scale + 'px';
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  showSuccess(summary?: string, detail?: string, sticky?: boolean, lifeTime?: number) {
    this.messageService.add({ severity: 'success', summary, detail, life: lifeTime });
  }

  showError(summary?: string, detail?: string, sticky?: boolean, lifeTime?: number) {
    this.messageService.add({ severity: 'error', summary, detail, life: lifeTime });
  }

  showWarning(summary?: string, detail?: string, sticky?: boolean, lifeTime?: number) {
    this.messageService.add({ severity: 'warn', summary, detail, life: lifeTime });
  }

  showInfo(summary?: string, detail?: string, sticky?: boolean, lifeTime?: number) {
    this.messageService.add({ severity: 'info', summary, detail, life: lifeTime });
  }

  blockDocument(blocked) {
    this.blockedDocument = blocked;
  }

  bindRouteEvents() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (typeof window['gtag'] === 'function') {
          window['gtag']('event', 'page_view', {
            page_path: event.urlAfterRedirects
          });
        }

        const { theme, darkMode } = this.configService.config();
        const landingTheme = darkMode ? 'aura-dark-blue' : 'aura-light-blue';
        if (event.urlAfterRedirects === '/' && theme !== landingTheme) {
          this.configService.config.update((config) => ({ ...config, theme: landingTheme, dark: darkMode }));
        }
      }
    });
  }
}
